import { CircleCheck, MoveRight, Phone } from "lucide-react";
import { images } from "../../assets/assets";
import Navbar from "../../Components/Navbar";
import { Link } from "react-router-dom";
import Footer from "../../Components/Footer";
import { getImageUrl } from "../../utils/getImageUrl";
import { useState, useEffect } from "react";
import { getAllDoctors } from "../../api";

const Doctors = () => {
  const [DoctorsData, setDoctorsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchDoctors = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await getAllDoctors();
        setDoctorsData(response?.data || []);
      } catch (err) {
        console.error("Error fetching doctors:", err);
        setError("Failed to load doctors. Please try again later.");
        setDoctorsData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchDoctors();
  }, []);

  // Skeleton Loader Component
  const SkeletonLoader = () => (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4 lg:gap-6 my-6 sm:my-8">
      {[1, 2, 3, 4, 5, 6].map((idx) => (
        <div key={idx}>
          <div className="rounded-[10px] overflow-hidden shadow-md">
            <div className="h-[300px] sm:h-[350px] md:h-[380px] lg:h-[420px] w-full bg-gray-200 animate-pulse"></div>
            <div className="p-3 px-4 space-y-2">
              <div className="h-5 bg-gray-200 rounded animate-pulse"></div>
              <div className="h-4 bg-gray-200 rounded w-3/4 animate-pulse"></div>
              <div className="h-3 bg-gray-200 rounded animate-pulse mt-2"></div>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-2 mt-3 sm:mt-2">
            <div className="h-10 bg-gray-200 rounded animate-pulse"></div>
            <div className="h-10 bg-gray-200 rounded animate-pulse"></div>
          </div>
        </div>
      ))}
    </div>
  );

  // const DoctorsData = [
  //   {
  //     Image: images.ExpertOne,
  //     name: "Dr. Amit Sharma",
  //     degree: "MBBS, MD (Cardiology)",
  //     experience: "10+",
  //     desc: "Dr. Amit Sharma is a highly experienced cardiologist specializing in the diagnosis and treatment of heart-related conditions. He focuses on preventive cardiac care, lifestyle management, and advanced treatment to ensure long-term heart health...",
  //     gradient:
  //       "linear-gradient(180.09deg, rgba(102, 102, 102, 0) 44.73%, rgba(21, 21, 21, 0.159116) 70.2%, rgba(0, 0, 0, 0.2) 92.76%)",
  //     textGradient:
  //       "linear-gradient(180.22deg, rgba(98, 121, 255, 0) 5.27%, rgba(81, 105, 241, 0.430369) 25.15%, rgba(71, 95, 233, 0.679016) 47.42%, #465FEF 89.57%)",
  //   },
  //   {
  //     Image: images.ExpertTwo,
  //     name: "Dr. Rajesh Verma",
  //     degree: "MBBS, MD (Cardiology)",
  //     experience: "10+",
  //     desc: "Dr. Rajesh Verma is an expert in critical care and emergency medicine, providing life-saving treatment and continuous monitoring for critically ill patients. He ensures timely intervention and advanced ICU care...",
  //     gradient:
  //       "linear-gradient(179.92deg, rgba(102, 102, 102, 0) 38.77%, rgba(12, 12, 12, 0.26413) 55.97%, rgba(21, 21, 21, 0.238674) 57.88%, rgba(0, 0, 0, 0.3) 89.05%)",
  //     textGradient:
  //       "linear-gradient(180.22deg, rgba(60, 153, 205, 0) 2.26%, rgba(61, 155, 207, 0.5) 32.37%, rgba(46, 135, 186, 0.7) 52.24%, #2F8EC2 84.15%)",
  //   },
  //   {
  //     Image: images.ExpertThree,
  //     name: "Dr. Neha Singh",
  //     degree: "MBBS, MD (General Medicine)",
  //     experience: "8+",
  //     desc: "Dr. Neha Singh provides comprehensive healthcare services under the 24-hour health program, focusing on patient monitoring, preventive care, and overall health management...",
  //     gradient:
  //       "linear-gradient(180.09deg, rgba(102, 102, 102, 0) 44.73%, rgba(21, 21, 21, 0.238674) 61.98%, rgba(12, 12, 12, 0.26413) 72.32%, rgba(0, 0, 0, 0.3) 90.1%)",
  //     textGradient:
  //       "linear-gradient(180.22deg, rgba(221, 138, 138, 0) 2.26%, rgba(187, 100, 100, 0.5) 32.37%, rgba(204, 111, 111, 0.6) 52.24%, #C66868 84.15%)",
  //   },
  //   {
  //     Image: images.ExpertFour,
  //     name: "Dr. Anil Kumar",
  //     degree: "MBBS, MD (Pediatrics)",
  //     experience: "9+",
  //     desc: "Dedicated pediatrician offering compassionate care for children, including vaccinations, growth monitoring, and illness treatment.",
  //     gradient:
  //       "linear-gradient(180.09deg, rgba(102, 102, 102, 0) 44.73%, rgba(21, 21, 21, 0.159116) 70.2%, rgba(0, 0, 0, 0.2) 92.76%)",
  //     textGradient:
  //       "linear-gradient(180.22deg, rgba(103, 168, 131, 0) 5.27%, rgba(102, 168, 130, 0.5) 25.15%, rgba(103, 168, 130, 0.8) 47.42%, #67A882 89.57%)",
  //   },
  //   {
  //     Image: images.ExpertFive,
  //     name: "Dr. Pooja Mehta",
  //     degree: "MBBS, MS (Ophthalmology)",
  //     experience: "7+",
  //     desc: "Eye care specialist providing advanced treatment for cataracts, glaucoma, and vision-related conditions.",
  //     gradient:
  //       "linear-gradient(180.09deg, rgba(102, 102, 102, 0) 44.73%, rgba(21, 21, 21, 0.238674) 61.98%, rgba(12, 12, 12, 0.26413) 72.32%, rgba(0, 0, 0, 0.3) 90.1%)",
  //     textGradient:
  //       "linear-gradient(180.22deg, rgba(191, 145, 109, 0) 2.26%, rgba(191, 145, 109, 0.5) 32.37%, rgba(191, 145, 109, 0.7) 52.24%, #BF916D 84.15%)",
  //   },
  //   {
  //     Image: images.ExpertSix,
  //     name: "Dr. Sandeep Yadav",
  //     degree: "MBBS, MS (Urology)",
  //     experience: "11+",
  //     desc: "Urology specialist experienced in kidney stone treatment, prostate care, and advanced minimally invasive procedures.",
  //     gradient:
  //       "linear-gradient(180.09deg, rgba(102, 102, 102, 0) 44.73%, rgba(21, 21, 21, 0.238674) 61.98%, rgba(12, 12, 12, 0.26413) 72.32%, rgba(0, 0, 0, 0.3) 90.1%)",
  //     textGradient:
  //       "linear-gradient(180.22deg, rgba(146, 118, 213, 0) 2.26%, rgba(146, 118, 213, 0.5) 32.37%, rgba(146, 118, 213, 0.7) 52.24%, #9276D5 84.15%)",
  //   },
  //   {
  //     Image: images.ExpertSix,
  //     name: "Dr. Rohan Desai",
  //     degree: "MBBS, MS (Orthopedics)",
  //     experience: "11+",
  //     desc: "Orthopedic expert focused on joint care, fracture treatment, and restoring mobility through advanced techniques.",
  //     gradient:
  //       "linear-gradient(180.09deg, rgba(102, 102, 102, 0) 44.73%, rgba(21, 21, 21, 0.238674) 61.98%, rgba(12, 12, 12, 0.26413) 72.32%, rgba(0, 0, 0, 0.3) 90.1%)",
  //     textGradient:
  //       "linear-gradient(180.22deg, rgba(146, 118, 213, 0) 2.26%, rgba(146, 118, 213, 0.5) 32.37%, rgba(146, 118, 213, 0.7) 52.24%, #9276D5 84.15%)",
  //   },
  // ];



  return (
    <div className="font-lato">
      <Navbar />
      {/* Top Page Heading */}
      <div className="bg-[#F7F7F7B2] py-4 sm:py-6 flex justify-center px-4">
        <div className="flex gap-2 sm:gap-4 items-center max-w-[1100px]">
          <img
            src={images.Logo}
            alt="logo"
            className="w-[50px] h-[50px] sm:w-[80px] sm:h-[80px] md:w-[110px] md:h-[110px] flex-shrink-0"
          />
          <div className="max-w-[500px]">
            <p className="font-bold text-[16px] sm:text-[20px] md:text-[22px]">
              Expert Doctors
            </p>
            <p className="font-openSans text-[12px] sm:text-[14px] md:text-[16px] leading-[1.2]">
              At Dev Rishi Hospital, we provide a wide range of medical services
              designed to meet every healthcare need. Our experienced doctors,
              advanced medical technology, and patient-centered approach ensure
              high-quality treatment and faster recovery.
            </p>
          </div>
        </div>
      </div>
      <div className="max-w-[1100px] mx-auto px-4">
        {/* Specialities */}
        <div className="flex flex-wrap justify-start sm:justify-between items-center gap-3 sm:gap-2 my-6 sm:my-4">
          <div className="flex gap-2 items-center">
            <div className="p-2 bg-[#E3A1A166] rounded-full flex-shrink-0">
              <CircleCheck color="#000" className="w-6 h-6" />
            </div>
            <p className="font-semibold text-[14px] sm:text-[16px] md:text-[18px]">
              Experienced Physicians
            </p>
          </div>
          <div className="flex gap-2 items-center">
            <div className="p-2 bg-[#C9DCDE] rounded-full flex-shrink-0">
              <CircleCheck color="#000" className="w-6 h-6" />
            </div>
            <p className="font-semibold text-[14px] sm:text-[16px] md:text-[18px]">
              Skilled Surgeons
            </p>
          </div>
          <div className="flex gap-2 items-center">
            <div className="p-2 bg-[#DFDAEC] rounded-full flex-shrink-0">
              <CircleCheck color="#000" className="w-6 h-6" />
            </div>
            <p className="font-semibold text-[14px] sm:text-[16px] md:text-[18px]">
              Certified Specialists
            </p>
          </div>
          <div className="flex gap-2 items-center">
            <div className="p-2 bg-[#E4A77F] rounded-full flex-shrink-0">
              <CircleCheck color="#000" className="w-6 h-6" />
            </div>
            <p className="font-semibold text-[14px] sm:text-[16px] md:text-[18px]">
              Patient-Friendly Doctors
            </p>
          </div>
        </div>
        {/* Doctors list */}
        {loading ? (
          <SkeletonLoader />
        ) : error ? (
          <div className="flex flex-col items-center justify-center my-12 py-16">
            <div className="text-center">
              <div className="text-red-500 text-6xl mb-4">⚠️</div>
              <h3 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-2">
                Unable to Load Doctors
              </h3>
              <p className="text-gray-600 mb-6">{error}</p>
              <button
                onClick={() => window.location.reload()}
                className="bg-[#1975FF] text-white px-6 py-2 rounded-lg hover:bg-[#1560d4] transition-all duration-300 font-semibold"
              >
                Try Again
              </button>
            </div>
          </div>
        ) : DoctorsData.length === 0 ? (
          <div className="flex flex-col items-center justify-center my-12 py-16">
            <div className="text-center">
              <div className="text-gray-300 text-6xl mb-4">👨‍⚕️</div>
              <h3 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-2">
                No Doctors Available
              </h3>
              <p className="text-gray-600">
                We're currently updating our doctor list. Please check back soon!
              </p>
            </div>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4 lg:gap-6 my-6 sm:my-8">
          {DoctorsData.map((expert, idx) => (
            <div key={idx}>
              <div className="group rounded-[10px] overflow-hidden cursor-pointer shadow-md hover:shadow-2xl transition-all duration-300 hover:-translate-y-2">
                <div
                  className="h-[300px] sm:h-[350px] md:h-[380px] lg:h-[420px] w-full bg-cover bg-center flex items-end text-white transition-all duration-500 group-hover:scale-[1.02]"
                  style={{
                    backgroundImage: `linear-gradient(180.09deg, rgba(102, 102, 102, 0) 44.73%, rgba(21, 21, 21, 0.159116) 70.2%, rgba(0, 0, 0, 0.2) 92.76%), url(${getImageUrl(expert.imagePath)})`,
                  }}
                >
                  <div
                    className="text-white text-base p-3 px-4 w-full transition-all duration-300"
                    style={{ background: `${expert.gradientColor}` }}
                  >
                    <h3 className="text-[16px] sm:text-[17px] md:text-[18px] lg:text-[20px] font-bold">
                      {expert.name}
                    </h3>
                    <p className="font-semibold text-[12px] sm:text-[13px] lg:text-[14px]">
                      {expert.degree} · {expert.experience} Years Exp.
                    </p>
                    <p className="mt-2 text-[12px] sm:text-[13px] lg:text-[14px] overflow-hidden line-clamp-3">
                      {Array.isArray(expert?.doctorDescription) ? expert.doctorDescription[0] : (typeof expert?.doctorDescription === 'string' ? expert.doctorDescription : "")}
                    </p>
                  </div>
                </div>
              </div>
              {/* Buttons */}
              <div className="grid grid-cols-2 gap-2 mt-3 sm:mt-2">
                <Link
                  to="/appointment"
                  className="w-full bg-[#1975FF] rounded-[8px] sm:rounded-[10px] py-2 sm:py-1.5 px-2 sm:px-3 flex items-center justify-center gap-1 text-[12px] sm:text-[13px] md:text-[14px] font-semibold text-white hover:bg-[#1560d4] hover:shadow-xl hover:-translate-y-1 active:bg-[#1050b8] active:scale-95 active:shadow-md transition-all duration-300 shadow-md group whitespace-nowrap relative overflow-hidden"
                >
                  <span className="absolute inset-0 bg-white opacity-0 group-hover:opacity-10 transition-opacity duration-300"></span>
                  <span className="relative">
                    Book <span className="hidden sm:inline">Appointment</span>
                  </span>
                  <span className="p-1.5 sm:p-2 bg-white rounded-full transition-all duration-300 group-hover:scale-125 group-hover:rotate-12">
                    <MoveRight
                      color="#000"
                      className="rotate-[-38deg] w-3 h-3 sm:w-3.5 sm:h-3.5 md:w-4 md:h-4"
                    />
                  </span>
                </Link>
                <Link
                  to={`/doctor-detail/${expert?.slug || ""}`}
                  className="w-full rounded-[8px] sm:rounded-[10px] py-2 sm:py-1.5 px-2 sm:px-3 text-[12px] sm:text-[13px] md:text-[14px] font-semibold text-[#1975FF] bg-white hover:bg-[#1975FF] hover:text-white hover:shadow-xl  active:bg-[#1560d4] active:scale-95 active:shadow-md transition-all duration-300 border border-[#1975FF] text-center relative overflow-hidden flex items-center justify-center"
                >
                  View Detail
                </Link>
              </div>
            </div>
          ))}
        </div>
        )}
      </div>
      {/*  Consult Expert  */}
      <div className="py-8 sm:py-10 md:py-12 bg-[#F7F7F7B2] px-4 mt-10 mb-14">
        <h1 className="max-w-[550px] text-center text-[20px] sm:text-[26px] md:text-[32px] font-semibold mx-auto leading-[1.2]">
          Consult Our Experts Today
        </h1>
        <p className="max-w-[600px] font-openSans text-[13px] sm:text-[16px] md:text-[18px] mx-auto text-center mt-3 px-2">
          Get the best medical advice and treatment from our experienced
          doctors. Book your appointment today for quick and reliable healthcare
          services.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center mt-8">
          <Link
            to="/appointment"
            className="bg-[#1975FF] rounded-[8px] sm:rounded-[10px] py-2 sm:py-1 pr-1 pl-3 sm:pl-4 flex items-center justify-center gap-2 text-[13px] sm:text-[14px] font-semibold text-white hover:bg-[#1560d4] hover:shadow-lg hover:-translate-y-0.5 active:bg-[#1050b8] active:scale-95 active:shadow-md transition-all duration-200 shadow-md group"
          >
            Book Appointment{" "}
            <span className="p-2 bg-white rounded-full transition-transform duration-300 group-hover:scale-110">
              <MoveRight
                color="#000"
                className="rotate-[-38deg] w-3.5 h-3.5 sm:w-4 sm:h-4"
              />
            </span>
          </Link>
          <a
            href="tel:+917300906444"
            className="border border-black rounded-[8px] sm:rounded-[10px] py-1.5 sm:py-0.5 px-3 sm:px-4 flex items-center justify-center gap-2 text-[13px] sm:text-[14px] font-semibold text-black bg-white hover:bg-black hover:text-white hover:shadow-lg hover:-translate-y-0.5 active:scale-95 active:shadow-md transition-all duration-200"
          >
            <span className="p-2 bg-[#F59E0B] rounded-full transition-all duration-300 group-hover:bg-white">
              <Phone color="#ffffff" className="w-3.5 h-3.5 sm:w-4 sm:h-4" />
            </span>
            Call Now
          </a>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Doctors;
